var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFillDrip = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.9,24.8c11.7-11.7,30.7-11.7,42.4,0l76.3,76.2l49.8-49.8c26.3-26.3,69.1-26.3,95.4,0l141.9,142 c26.3,26.3,26.3,69.1,0,95.4L284.2,467.3c-35.2,35.2-92.2,35.2-127.3,0L46.8,357.2c-35.2-35.2-35.2-92.2,0-127.3l86.3-86.3 L56.9,67.2C45.2,55.5,45.2,36.4,56.9,24.8L56.9,24.8z M221.9,232.3L175.6,186l-86.3,86.3c-3.9,3.9-6.6,8.7-7.9,13.7h299.3l39.7-39.7 c2.9-2.9,2.9-7.7,0-10.6l-141.9-142c-2.9-2.9-7.7-2.9-10.6,0L218,143.5l46.3,46.3c11.7,11.7,11.7,30.8,0,42.5 C252.6,244,233.6,244,221.9,232.3L221.9,232.3z M498.1,496c-33.1,0-60-26.9-60-60c0-23.6,30.6-74.6,48-101.9 c5.6-8.8,18.3-8.8,23.9,0c17.5,27.3,48.1,78.3,48.1,101.9C558.1,469.1,531.2,496,498.1,496z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFillDrip);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/FillDrip.85f026ebee08b88db9175da828465543.svg";